import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../redux';
import { setShopMode } from '../redux/actions/shopMode.actions';
import { ShopMode } from '../redux/types';
import { getAuthenticationState } from '../redux/selectors';

/**
 * Hook per inizializzare shopMode al caricamento dell'applicazione.
 *
 * Logica:
 * - Se shopMode è già impostato (presente in localStorage), non fa nulla
 * - Se shopMode è null (non presente in localStorage):
 *   - Se l'utente è loggato → imposta automaticamente LocalDelivery
 *   - Se l'utente non è loggato → apre il dialog di selezione
 *
 * @param onOpenDialog - Callback per aprire il dialog di selezione shopMode
 */
export const useShopModeInitialization = (onOpenDialog: () => void) => {
  const dispatch = useDispatch();
  const shopMode = useSelector((state: AppState) => state.shopMode.mode);
  const user = useSelector((state: AppState) => getAuthenticationState(state).user);

  useEffect(() => {
    // Se shopMode è già impostato, non fare nulla
    if (shopMode !== null) {
      return;
    }

    // shopMode è null (non presente in localStorage)
    if (user) {
      // Utente loggato → imposta LocalDelivery silenziosamente
      dispatch(setShopMode(ShopMode.LocalDelivery));
    } else {
      // Utente non loggato → apri il dialog di selezione
      onOpenDialog();
    }
  }, [shopMode, user, dispatch, onOpenDialog]);
};
